@if (embedded) {
@if (hasAnyOption) {
<div class="company-switcher-embedded">
    @if (canSwitchCompany) {
    <button
        type="button"
        class="company-switcher-embedded__action"
        [disabled]="switching"
        (click)="openCompanySwitch()">
        <mat-icon
            class="icon-size-5 company-switcher-embedded__action-icon"
            [svgIcon]="'heroicons_outline:building-office-2'"></mat-icon>
        <span>Switch Company</span>
    </button>
    }
    @if (canSwitchBranch) {
    <button
        type="button"
        class="company-switcher-embedded__action"
        [disabled]="switching"
        (click)="openBranchSwitch()">
        <mat-icon
            class="icon-size-5 company-switcher-embedded__action-icon"
            [svgIcon]="'heroicons_outline:building-storefront'"></mat-icon>
        <span>Switch Branch</span>
    </button>
    }
</div>
}
} @else if (hasContext) {
<!-- Company / branch context badge (always visible so the user knows where they are) -->
<div
    class="company-context-badge"
    [class.company-context-badge--interactive]="hasAnyOption"
    [matMenuTriggerFor]="hasAnyOption ? switcherMenu : null"
    [attr.role]="hasAnyOption ? 'button' : null"
    [attr.tabindex]="hasAnyOption ? 0 : null"
    [matTooltip]="hasAnyOption ? 'Switch company / branch' : 'Current company / branch'"
>
    <div class="company-context-badge__text">
        <span class="company-context-badge__company" [title]="currentCompanyName">
            {{ currentCompanyName || 'No company' }}
        </span>
        @if (currentBranchName) {
        <span class="company-context-badge__branch" [title]="currentBranchName">
            <mat-icon
                class="icon-size-3 company-context-badge__branch-icon"
                [svgIcon]="'heroicons_mini:map-pin'"
            ></mat-icon>
            {{ currentBranchName }}
        </span>
        }
    </div>

    @if (hasAnyOption) {
    <mat-icon
        class="icon-size-4 company-context-badge__chevron"
        [class.company-context-badge__chevron--spin]="switching"
        [svgIcon]="switching ? 'heroicons_outline:arrow-path' : 'heroicons_mini:chevron-down'"
    ></mat-icon>
    }
</div>

<mat-menu #switcherMenu="matMenu" class="company-switcher-menu">
    @if (canSwitchCompany) {
    <button mat-menu-item [disabled]="switching" (click)="openCompanySwitch()">
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:building-office-2'"></mat-icon>
        <span>Switch Company</span>
    </button>
    }
    @if (canSwitchBranch) {
    <button mat-menu-item [disabled]="switching" (click)="openBranchSwitch()">
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:building-storefront'"></mat-icon>
        <span>Switch Branch</span>
    </button>
    }
</mat-menu>
}
